module.exports = __webpack_public_path__ + "static/u-wierzby-pod-lasem_polska-mapa-55af770501391e31732ace4636ad0b68.jpg";